module.exports = __webpack_public_path__ + "static/media/background.98660bce.png";